export default __webpack_public_path__ + "static/media/edit.0ee2589a.svg";